<gatewee-api-keys
  [keys]="keys"
  [actions]="apiKeyActions"
  [breadcrumb]="breadcrumb"
  [title]="'features.apiKeys.title'"
  [titlePath]="'features.apiKeys.titlePath'"
  [page]="page"
  [pageSize]="pageSize"
  [total]="total"
  (pageChange)="onPageChange($event)"
></gatewee-api-keys>
